module.exports = __webpack_public_path__ + "img/tradition.f66c550d.png";